export const isAddress = (address) => 'zip_code' in address || 'address1' in address;
export const isContactAddress = (address) => 'zip' in address || 'address_line_1' in address;
